const config = {
  baseUrl: 'https://th-api.dimorder.com',
};

export default config;
